import {NavigationLinkOptions} from '@deere/fuel-react';
import {AnchorLink} from 'components/AnchorLink';
import {useLocation} from 'react-router-dom';
import {AdminReqUserCheck, BillingUserCheck, BulkLoadUserCheck, ScheduledClassesUserCheck} from '../components/UserPermissions';

type CreateDropDownMenuFunc = (label: string, subNavItems: object) => NavigationLinkOptions;

type CreateMenuFunc = (label: string, url: string) => NavigationLinkOptions;

type UseNavigationItemsHook = () => NavigationLinkOptions[];

const useCreateDropDownMenu: CreateDropDownMenuFunc = (label, subNavItems) => {
    const location = useLocation();

    const subNavigationItems = Object.entries(subNavItems).map(([subLabel, url]) => ({
        component: AnchorLink,
        href: url,
        label: subLabel,
        selected: location.pathname === url
    }));

    return {
        label,
        subNavigationItems
    };
};

const useCreateMenu: CreateMenuFunc = (label, url) => {
    const location = useLocation();

    return {
        component: AnchorLink,
        href: url,
        label,
        selected: location.pathname === url
    };
};

const useAdminRequests = (navArr: NavigationLinkOptions[]): void => {
    const adminTab = useCreateDropDownMenu('Admin Requests', {
        'New Request': '/newadminrequest',
        'My Requests': '/myadminrequests'
    });

    if (AdminReqUserCheck()) {
        navArr.push(adminTab);
    }
};

const useAddClassRequests = (navArr: NavigationLinkOptions[]): void => {
    const classAdministration: {
        'Class Requests': string;
        'Scheduled Class'?: string; // Optional property
        'Bulk Class Load'?: string; // Optional property
    } = {
        'Class Requests': '/requestclass'
    };

    if (BulkLoadUserCheck()) {
        classAdministration['Bulk Class Load'] = '/bulkclassloadrequest';
    }
    if (ScheduledClassesUserCheck()) {
        classAdministration['Scheduled Class'] = '/scheduledclasshistory';
    }

    navArr.push(useCreateDropDownMenu('Class Administration', classAdministration));
};

const useAddBilling = (navArr: NavigationLinkOptions[]): void => {
    const jduBillingTab = useCreateMenu('JDU Billing (Internal)', '/jdubilling');

    // This check needs to be updated for JDU billing admin AD group
    if (BillingUserCheck()) {
        navArr.push(jduBillingTab);
    }
};

export const useNavigationItems: UseNavigationItemsHook = () => {
    const navArr: NavigationLinkOptions[] = [];

    useAdminRequests(navArr);
    useAddClassRequests(navArr);
    useAddBilling(navArr);

    return navArr;
};
